import React from "react";
import CustomSelect from "./select.js";
import { getTranslation } from "../../utils/translate.js";

/**
 * GroupSelector Component
 * 
 * This component allows users to select a group to configure.
 * It's part of the dish configuration flow.
 */
const GroupSelector = ({
    availableGroups,
    onGroupSelect,
    placeholder,
    language,
    label
}) => {
    const handleChange = (selectedOption) => {
        if (selectedOption && selectedOption.value) {
            onGroupSelect(selectedOption);
        }
    };

    return (
        <div className="mb-2">
            <CustomSelect
                fieldName="additionGroupSelector"
                onChange={handleChange}
                value={null} // Always reset to null after selection for better UX
                name="additionGroupSelector"
                options={availableGroups}
                placeholder={placeholder || getTranslation('menu.selectGroup', language)}
                label={label || getTranslation('menu.addConfigurationGroup', language)}
                isClearable={true}
                className="text-base py-2" // Larger text and padding for mobile
                menuPortalTarget={document.body} // Prevent dropdown from being cut off on mobile
            />
        </div>
    );
};

export default GroupSelector; 